import { AxiosError } from "axios";
import { useEffect, useState } from "react";

import { PaymentMethod } from "@/types/PaymentMethod";
import { PAYMENT_METHOD_STATUS } from "@/utils/InvoicePay";

import { getErrorMessage } from "../utils/getErrorMessage";
import { listPaymentMethodsApi } from "../utils/PaymentsService/PaymentMethodApis";

interface UseSavedPaymentMethodProps {
  allPaymentMethods: PaymentMethod[];
  defaultPaymentMethod: PaymentMethod | undefined;
  loading: boolean;
  error: string | null;
}

export const useSavedPaymentMethods = (): UseSavedPaymentMethodProps => {
  const [allPaymentMethods, setAllPaymentMethods] = useState<PaymentMethod[]>(
    []
  );
  const [defaultPaymentMethod, setDefaultPaymentMethod] = useState<
    PaymentMethod | undefined
  >(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getSavedPaymentMethods = async () => {
      try {
        const res = await listPaymentMethodsApi({
          status: PAYMENT_METHOD_STATUS.ACTIVE
        });
        const allMethods: PaymentMethod[] = res.data.paymentMethodsList;
        const defaultMethod =
          allMethods.find((pm) => pm.isDefault) || allMethods[0];
        setDefaultPaymentMethod(defaultMethod);
        setAllPaymentMethods(allMethods);
      } catch (err: unknown) {
        let message = "Error";
        if (err instanceof AxiosError && err.response?.data?.errorCode) {
          message = getErrorMessage(err.response.data.errorCode);
        }
        setError(message);
      } finally {
        setLoading(false);
      }
    };

    getSavedPaymentMethods();
  }, []);

  return { allPaymentMethods, defaultPaymentMethod, loading, error };
};
